import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const CTASection = styled.section`
  background-color: #ff6e6e;
  padding: 80px 0;
  text-align: center;
  color: #fff;
  
  @media (max-width: 768px) {
    padding: 60px 0;
  }
  
  @media (max-width: 576px) {
    padding: 40px 0;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  
  @media (max-width: 576px) {
    padding: 0 15px;
  }
`;

const CTATitle = styled(motion.h2)`
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 28px;
  }
  
  @media (max-width: 576px) {
    font-size: 24px;
    margin-bottom: 15px;
  }
`;

const CTADescription = styled(motion.p)`
  font-size: 18px;
  max-width: 700px;
  margin: 0 auto 30px;
  opacity: 0.9;
  
  @media (max-width: 768px) {
    font-size: 16px;
    max-width: 90%;
  }
  
  @media (max-width: 576px) {
    font-size: 15px;
    margin-bottom: 20px;
  }
`;

const CTAButton = styled(motion.a)`
  display: inline-block;
  background-color: #fff;
  color: #ff6e6e;
  font-weight: 600;
  padding: 15px 30px;
  border-radius: 50px;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #333;
    color: #fff;
    transform: translateY(-3px);
  }
  
  @media (max-width: 768px) {
    padding: 12px 25px;
    font-size: 15px;
  }
  
  @media (max-width: 576px) {
    padding: 10px 20px;
    font-size: 14px;
    display: block;
    max-width: 200px;
    margin: 0 auto;
  }
`;

const Contact = () => {
  return (
    <>
      <CTASection>
        <Container>
          <CTATitle
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Ready to Get Started?
          </CTATitle>
          <CTADescription
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            Contact us today to discuss how our services can help your business grow.
          </CTADescription>
          <CTAButton
            href="/contact-us"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Contact Us Now
          </CTAButton>
        </Container>
      </CTASection>
    </>
  );
};

export default Contact;